import { render, staticRenderFns } from "./PhotosModal.vue?vue&type=template&id=3eddc9c4&scoped=true&"
import script from "./PhotosModal.vue?vue&type=script&lang=js&"
export * from "./PhotosModal.vue?vue&type=script&lang=js&"
import style0 from "./PhotosModal.vue?vue&type=style&index=0&id=3eddc9c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eddc9c4",
  null
  
)

export default component.exports